export class FilterSearch{

  search(data, input, method){
    let array = [];

    // search = retornar varios objetos com nomes parecidos com o input
    // verification = retornar se existe aquele valor

    //for no array de objetos
    for (let i = 0; i < data.length; i++) {

      let object_complete = data[i];

      //busca somente valores do objeto e converter em array
      let convert_values_objet_array = Object.values(data[i]);

      //checa se cada valor do objeto possui o valor pesquisado, se isto for verdadeiro é feito o push para variavel pdvs
      for (let j = 0; j < convert_values_objet_array.length; j++) {

        let value_only_object = this.normalizaString(convert_values_objet_array[j])
        const data_object = convert_values_objet_array[j];

        switch (method) {
          case 'search':
            // Verificando se ele o input existe
            if(value_only_object.includes(this.normalizaString(input))){

              if(!array.includes(object_complete)){
                array.push(object_complete)
              }
            }

            // Verificando se o input existe dentro do objeto
            if(typeof data_object === "object"){
              const value_object = Object.values(data_object)  
              const value_only_object = this.normalizaString(value_object)
              
              if(value_only_object.includes(this.normalizaString(input))){

                // Se já tiver no array então não grave
                if(!array.includes(object_complete)){
                  array.push(object_complete)
                }
              }
            } 

            break;

          case 'verification':
            if (value_only_object == input.toLocaleLowerCase()) {
              value_only_object.includes(this.normalizaString(input)) ? array.push(object_complete) : false;
            }
            break;
        }
      }
    }

    return array;
  }

  normalizaString(value) {
    //método para remover acentos e converter letras em minúsculas

    return String(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
}

